interface AirportTransferRecommendationResult {
  id: string
  maxPassengers?: number
  maxCheckedBags?: number
}

export function getTopPickCarsAirportTransferResultId(
  results: Array<AirportTransferRecommendationResult>,
  requestedPassengers: number,
  requestedCheckedBags: number,
): string | undefined {
  if (!results.length) return undefined

  const getCapacityDifference = (
    result: AirportTransferRecommendationResult,
  ): number => {
    if (
      result.maxPassengers === undefined ||
      result.maxCheckedBags === undefined ||
      result.maxPassengers < requestedPassengers ||
      result.maxCheckedBags < requestedCheckedBags
    ) {
      return Number.POSITIVE_INFINITY
    }

    return (
      result.maxPassengers - requestedPassengers +
      result.maxCheckedBags - requestedCheckedBags
    )
  }

  return results.reduce((topPick, result) =>
    getCapacityDifference(result) < getCapacityDifference(topPick)
      ? result
      : topPick,
  ).id
}
